import { CpsLoaderKey } from '@cs-cms/types';
import React, { useState } from 'react';
import { LoaderContext } from '../contexts/CpsLoaderContext';

interface LoaderProviderProps {
  children?: React.ReactNode;
}

export const CpsLoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [loadersMap, setLoadersMap] = useState<Map<CpsLoaderKey, number>>(new Map());

  const showLoader = (isVisible: boolean, loaderKey: CpsLoaderKey): void => {
    setLoadersMap(prev => {
      const newMap = new Map(prev);
      const currentCount = prev.get(loaderKey) ?? 0;

      if (isVisible) {
        newMap.set(loaderKey, currentCount + 1);
      } else {
        const newCount = currentCount - 1;
        if (newCount <= 0) {
          newMap.delete(loaderKey);
        } else {
          newMap.set(loaderKey, newCount);
        }
      }

      return newMap;
    });
  };

  const clearAllLoaders = (): void => {
    setLoadersMap(new Map());
  };

  return (
    <LoaderContext.Provider value={{ showLoader, clearAllLoaders, isLoading: loadersMap.size > 0 }}>
      {children}
    </LoaderContext.Provider>
  );
};
